export function Breadcrumb({ items }) {
  return (
    <nav className="breadcrumb" aria-label="Breadcrumb" data-testid="home-breadcrumb">
      {items.map((item, index) => (
        <span key={item.label} data-testid={`breadcrumb-item-${index}`}>
          {item.href ? <a href={item.href} data-testid={`breadcrumb-link-${index}`}>{item.label}</a> : item.label}
          {index < items.length - 1 && <span aria-hidden="true">›</span>}
        </span>
      ))}
    </nav>
  );
}